import { forEach } from 'async';
import * as moment from 'moment';
import * as global from 'src/globals';

export class htmlStringUtility {

    public static async getHtmlString_Mobile(
        bookingSlot: any,
        clubImage: string,
        clubName: string,
        clubCourse: string,
        bookingStatus: string
    ) {
        console.log(bookingSlot,'bookingSlot')
        const _amountChargable = (
            bookingSlot.amountPayable - bookingSlot.totalDeductions
        ).toFixed(2);

        const topGradient = `../assets/image/homeImg/topGradient.png`;
        const calendarGray = `../assets/icons/calendarGary.svg`;
        const ClockGary = `../assets/icons/ClockGary.svg`;
        const logo = `../assets/image/homeImg/newLogo.png`;


        const playerProfilePicture = getProfilePicture(
            bookingSlot?.bookedByUser?.profile
        );

        const createdDay = moment(
            bookingSlot?.slotAssigned?.teeOffDate
        ).format('ddd, DD MMM YYYY');
        const createdTime = moment(bookingSlot?.slotAssigned?.teeOffTime, 'HH:mm:ss').format('hh:mm A');
        const bookedOn = moment(bookingSlot.bookingCreatedAt).format(
            'ddd, DD MMM YYYY'
        );

        const playersHTML = await getPlayer(bookingSlot.bookingPlayers)
        // bookingSlot.bookingPlayers
        //   .map((player, index) => getPlayerHTML(player, index))
        //   .join('');

        return `
        <html lang="en">
         <head>
          <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no">
            <title>Booking Details</title>
            <style>
                * {
        box-sizing: border-box;
      }

      body {
        margin: 0;
        padding: 0;
        font-family: Garant Pro, sans-serif;
        background-color: #f2f2f2;
      }

      .overlay-image {
        position: absolute;
        bottom: 20px;
        left: 50%;
        transform: translateX(-50%);
        z-index: 1;
      }

      .booking-container {
        position: relative;
        text-align: center;
        background: url(${topGradient}) no-repeat bottom center,
          linear-gradient(180deg, #609200 0%, #2d4f00 100%);
        padding: 10px 12px 100px;
        width: 100%;
        max-width: 100%;
      }

      .booking-container span {
        font-size: 18px;
        font-weight: 700;
        line-height: 33px;
        color: #fff;
        display: inline-block;
        margin-bottom: 10px;
      }

      .booking-content {
        background: #fff;
        border-radius: 15px;
        padding: 15px;
      }

      .user-data,
      .user-data-one,
      .user-data-two {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-top: 8px;
      }

      .user-img img {
        width: 50px;
        height: 50px;
        border-radius: 12px;
        object-fit: cover;
        border: 1px solid #fff;
      }

      .user-name p,
      .booking-club-by p,
      .booking-player p {
        font-size: 12px;
        font-weight: 500;
        color: #231f20;
        opacity: 0.5;
        margin: 0 0 2px 0;
        text-align: left;
      }

      .user-name h5,
      .booking-club-by h5,
      .booking-player h5 {
        font-size: 14px;
        font-weight: 700;
        color: #231f20;
        margin: 0;
        text-align: left;
        word-wrap: break-word;
      }

     
    .booking-time {
    display: flex;
    justify-content: space-between;
    border: 1px solid #ccc;
    border-radius: 12px;
    padding: 6px;
    margin-top: 8px;
    align-item:center;
    padding: 6px 10px;
    }

    .booking-time span {
    font-size: 14px;
    font-weight: 700;
    color: rgba(35, 31, 32, 1);
    margin: 0px
    }

      .club-detail,
      .player-detail {
        padding-top: 8px;
        text-align: left;
      }

      .club-detail span,
      .player-detail span {
        font-size: 12px;
        font-weight: 500;
        color: #89d821;
        display: block;
        margin-bottom: 4px;
      }

      .club-info {
        width: 100%;
        margin-top: 6px;
      }

      .club-info th {
        font-size: 12px;
        color: #979797;
        font-weight: 500;
        text-align: start;
      }

      .club-info td {
        font-size: 14px;
        font-weight: 700;
        color: #231f20;
        text-align: start;
      }

      .user-info {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
      }

      .user-data-one .user-img img,
      .user-data-two .user-img img {
        width: 30px;
        height: 30px;
      }

      .user-data-one .user-name p,
      .user-data-two .user-name p {
        font-size: 10px;
        margin: 5px 0 0 0;
      }

      .user-data-one .user-name h5,
      .user-data-two .user-name h5 {
        font-size: 12px;
      }

      img {
        max-width: 100%;
        height: auto;
      }

      table {
        width: 100%;
        border-spacing: 0;
      }

      @media (max-width: 480px) {
        // .booking-time {
        //   flex-direction: column;
        //   align-items: flex-start;
        // }

        // .booking-time > div {
        //   margin-bottom: 5px;
        // }

        .user-info {
          flex-direction: column;
        }

        .overlay-image img {
          width: 80px;
        }
      }
            </style>
          </head>
          <body>
            <div class="booking-container">
              <span>Booking Details</span>
              <div class="booking-content">
                <div class="user-data">
                  <div class="user-img">
                    <img src="${playerProfilePicture}" alt="User Image" />
                  </div>
                  <div class="booking-club-by" >
                    <p>Booked by</p>
                    <h5>${bookingSlot?.bookedByUser?.name}</h5>
                  </div>
                </div>
          
                <div class="booking-time">
                  <div style="display: flex; align-items: center ; gap: 5px;">
                    <img src="${calendarGray}" alt="Calendar Icon" />
                    <span>${createdDay}</span>
                  </div>
                  <div style="display: flex; align-items: center ; gap: 5px;">
                    <img src="${ClockGary}" alt="Clock Icon" />
                    <span>${createdTime}</span>
                  </div>
                </div>
        
                  <hr style="margin-top: 10px;" />
        
                <div class="club-detail">
                  <span>Club Information</span>
                  <div class="user-data">
                    <div class="user-img">
                      <img src="${clubImage}" alt="Club Image" />
                    </div>
                    <div class="booking-club-by">
                      <h5>${clubName}</h5>
                      <p>${clubCourse}</p>
                    </div>
                  </div>
                </div>
        
                  <hr style="margin: 2px 0;" />
        
                <div class="club-info">
                  <table>
                    <tr>
                      <th>Reference no.</th>
                      <th>Booked on</th>
                    </tr>
                    <tr>
                      <td>#${bookingSlot?.bookingReference}</td>
                      <td>${bookedOn}</td>
                    </tr>
                    <tr>
                      <th>Status</th>
                      <th>Total (${bookingSlot?.slotAssigned?.currency?.symbol})</th>
                    </tr>
                    <tr>
                      <td>${bookingStatus}</td>
                      <td>${_amountChargable}</td>
                    </tr>
                  </table>
                </div>
        
                <hr style="margin-top: 10px;" />
        
                <div class="club-detail">
                  <span>Player Details</span>
                  ${playersHTML}
                </div>
              </div>
              <div class="overlay-image">
                <img width="120px" src="${logo}" alt="Logo" />
              </div>
            </div>
          </body>
        </html>`;
    }
    public static async getHtmlString_Desktop(
        bookingSlot: any,
        clubImage: string,
        clubName: string,
        clubCourse: string,
        bookingStatus: string
    ) {
        const _amountChargable = (
            bookingSlot.amountPayable - bookingSlot.totalDeductions
        ).toFixed(2);

        const topGradient = `../assets/image/homeImg/topGradient.png`;
        const calendarGray = `../assets/icons/calendarGary.svg`;
        const ClockGary = `../assets/icons/ClockGary.svg`;
        const logo = `../assets/image/homeImg/newLogo.png`;


        const playerProfilePicture = getProfilePicture(
            bookingSlot?.bookedByUser?.profile
        );

        const createdDay = moment(
            bookingSlot?.slotAssigned?.teeOffDate,'YYYY-MM-DD'
        ).format('ddd, DD MMM YYYY');

        const createdTime = moment(bookingSlot?.slotAssigned?.teeOffTime, 'HH:mm:ss').format('hh:mm A');
        const bookedOn = moment(bookingSlot.bookingCreatedAt).format(
            'ddd, DD MMM YYYY'
        );

        const playersHTML = await getPlayer(bookingSlot.bookingPlayers)
        // bookingSlot.bookingPlayers
        //   .map((player, index) => getPlayerHTML(player, index))
        //   .join('');

        return `
       <html lang="en">
          <head>
          <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no">
            <title>Booking Details</title>
            <style>
  html {
    -webkit-text-size-adjust: none; /* Chrome, Safari, iOS */
    -moz-text-size-adjust: none;    /* Firefox */
    -ms-text-size-adjust: none;     /* IE */
    text-size-adjust: none;         /* Standard property */
    font-size: 100%;
  }
    body {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  transform: scale(1.5); /* adjust if needed */
  transform-origin: top left;
}
              .overlay-image {
                position: absolute;
                top: 95%;
                left: 50%;
                transform: translate(-50%, -50%);
                z-index: 1;
              }

              .booking-container {
                position: relative;
                text-align: center;
                background: url(${topGradient}) no-repeat bottom center,
                  linear-gradient(180deg, #609200 0%, #2d4f00 100%);
                padding: 35px 12px 85px;
                box-sizing: border-box;
                width: 100%;
                max-width: 375px;
                margin: auto;
              }

              .booking-container span {
                font-family: Garant Pro;
                font-size: 18px;
                font-weight: 700;
                line-height: 33.46px;
                text-align: center;
                color: rgba(255, 255, 255, 1);
                display: inline-block;
                margin-bottom: 10px;
              }

              .booking-content {
                background: #ffffff;
                border-radius: 15px;
                padding: 15px;
              }

              .user-data {
                display: flex;
                align-items: center;
                gap: 8px;
              }

              .user-img img {
                width: 50px;
                height: 50px;
                border: 1px solid #fff;
                border-radius: 12px;
              }

              .user-name p {
                font-family: Garant Pro;
                font-size: 12px;
                font-weight: 500;
                text-align: left;
                color: rgba(35, 31, 32, 1);
                text-transform: capitalize;
                opacity: 0.5;
                margin: 0 0 2px 0;
              }

              .user-name h5 {
                font-family: Garant Pro;
                font-size: 14px;
                font-weight: 700;
                text-align: left;
                color: rgba(35, 31, 32, 1);
                margin: 0;
                max-width: 100px;
                word-wrap: break-word;
                white-space: normal;
              }


               .booking-club-by p {
                font-family: Garant Pro;
                font-size: 12px;
                font-weight: 500;
                text-align: left;
                color: rgba(35, 31, 32, 1);
                text-transform: capitalize;
                opacity: 0.5;
                margin: 0 0 2px 0;
              }

              .booking-club-by h5 {
                font-family: Garant Pro;
                font-size: 14px;
                font-weight: 700;
                color: rgba(35, 31, 32, 1);
                margin: 0;
              }


               .booking-player p {
                font-family: Garant Pro;
                font-size: 12px;
                font-weight: 500;
                text-align: left;
                color: rgba(35, 31, 32, 1);
                text-transform: capitalize;
                opacity: 0.5;
                margin: 0 0 2px 0;
              }

              .booking-player h5 {
                font-family: Garant Pro;
                font-size: 12px;
                font-weight: 700;
                color: rgba(35, 31, 32, 1);
                margin: 0;
              }

              .booking-time {
                display: flex;
                justify-content: space-between;
                border: 1px solid #ccc;
                border-radius: 12px;
                padding: 6px;
                margin-top: 8px;
                align-item:center
              }

              .booking-time span {
                font-family: Garant Pro;
                font-size: 14px;
                font-weight: 700;
                color: rgba(35, 31, 32, 1);
                margin: 0px
              }

              .club-detail {
                text-align: justify;
                padding-top: 8px;
              }

              .club-detail span {
                font-family: Garant Pro;
                font-size: 12px;
                font-weight: 500;
                line-height: 19px;
                color: rgba(137, 216, 33, 1);
              }

              .club-info {
                text-align: justify;
              }

              .club-info th {
                font-size: 12px;
                color: rgba(151, 151, 151, 1);
                font-weight: 500;
                text-align: start;
                text-transform: capitalize;
              }

              .club-info td {
                font-size: 14px;
                color: rgba(35, 31, 32, 1);
                font-weight: 700;
                text-align: start;
                text-transform: capitalize;
              }

              .player-detail {
                padding-top: 8px;
              }

              .player-detail span {
                font-family: Garant Pro;
                font-size: 12px;
                font-weight: 500;
                line-height: 19px;
                color: rgba(137, 216, 33, 1);
              }

              .user-info {
                display: flex;
                justify-content: space-between;
                align-items: center;
              }

              .user-data-one,
              .user-data-two {
                display: flex;
                align-items: center;
                gap: 8px;
                margin-top: 8px;
              }

              .user-data-one .user-img img,
              .user-data-two .user-img img {
                width: 30px;
                height: 30px;
                border: 1px solid #fff;
                border-radius: 12px;
              }

              .user-data-one .user-name p,
              .user-data-two .user-name p {
                font-family: Garant Pro;
                font-size: 10px;
                font-weight: 500;
                color: rgba(35, 31, 32, 1);
                opacity: 0.5;
                margin: 5px 0 0 0;
              }

              .user-data-one .user-name h5,
              .user-data-two .user-name h5 {
                font-family: Garant Pro;
                font-size: 12px;
                font-weight: 700;
                color: rgba(35, 31, 32, 1);
                margin: 0;
              }
            </style>
          </head>
          <body>
            <div class="booking-container">
              <span>Booking Details</span>
              <div class="booking-content">
                <div class="user-data">
                  <div class="user-img">
                    <img src="${playerProfilePicture}" alt="User Image" />
                  </div>
                  <div class="booking-club-by" >
                    <p>Booked by</p>
                    <h5>${bookingSlot?.bookedByUser?.name}</h5>
                  </div>
                </div>

                <div class="booking-time">
                  <div style="display: flex; align-items: center ; gap: 5px;">
                    <img src="${calendarGray}" alt="Calendar Icon" />
                    <span>${createdDay}</span>
                  </div>
                  <div style="display: flex; align-items: center ; gap: 5px;">
                    <img src="${ClockGary}" alt="Clock Icon" />
                    <span>${createdTime}</span>
                  </div>
                </div>

                <div style="border-bottom: 1px solid #ccc; margin-top: 10px;"></div>

                <div class="club-detail">
                  <span>Club Information</span>
                  <div class="user-data">
                    <div class="user-img">
                      <img src="${clubImage}" alt="Club Image" />
                    </div>
                    <div class="booking-club-by">
                      <h5>${clubName}</h5>
                      <p>${clubCourse}</p>
                    </div>
                  </div>
                </div>

                <div style="border-bottom: 1px solid #ccc; margin: 2px 0;"></div>

                <div class="club-info">
                  <table width="100%" cellspacing="0" cellpadding="4">
                    <tr>
                      <th>Reference no.</th>
                      <th>Booked on</th>
                    </tr>
                    <tr>
                      <td>#${bookingSlot?.bookingReference}</td>
                      <td>${bookedOn}</td>
                    </tr>
                    <tr>
                      <th>Status</th>
                      <th>Total (${bookingSlot?.slotAssigned?.currency?.symbol})</th>
                    </tr>
                    <tr>
                      <td>${bookingStatus}</td>
                      <td>${_amountChargable}</td>
                    </tr>
                  </table>
                </div>

                <div style="border-bottom: 1px solid #ccc; margin-top: 10px;"></div>

                <div class="club-detail">
                  <span>Player Details</span>
                  ${playersHTML}
                </div>
              </div>
              <div class="overlay-image">
                <img width="120px" src="${logo}" alt="Logo" />
              </div>
            </div>
          </body>
        </html>`;
    }
}

function getProfilePicture(profile: any): string {
    if (profile?.photo) {
        return `https://${global.MygolfServerHost}/${profile.photo}`;
    }
    if (profile?.profileImage) {
        return `https://${global.MygolfServerHost}/${profile.profileImage}`;
    }
    return `../assets/img/default-user.jpg`;
}

async function getPlayerHTML(player: any, index: number): Promise<string> {
    const playerImage = player?.player?.profile
        ? player?.player?.profile
        : player?.player?.image ? player?.player?.image : `../assets/img/default-user.jpg`;
    const playerName = player.playerName || '';
    const playerType = player.playerType?.name || '';
    const playerId = player?.player?.id ? ('#'+ player?.player?.id ) : ''
    
    return `
    <div class="user-data" style="margin-bottom: 8px;">
        <div class="user-img">
            <img src="${playerImage}" alt="Player Image"/>
        </div>
        <div class="booking-player">
            <h5>${playerName || ''}</h5>
            <p>${playerId} | ${playerType || ''}</p>
        </div>
    </div>`;

}

async function getPlayer(players: any): Promise<string> {
    let htmlContent = '';
    for (let index = 0; index < players.length; index++) {
        const element = players[index];

        // if (index == 0 || index == 2 || index == 4) {
        //     htmlContent += ` <div class="user-info" style="padding-bottom: 8px">`;
        //     htmlContent += await getPlayerHTML(element, index);
        // }
        // if (index == 1 || index == 3 || index == 5) {
        //     htmlContent += await getPlayerHTML(element, index);
        //     htmlContent += `</div>`;
        // }

        htmlContent += await getPlayerHTML(element, index);
    }
    return htmlContent;
}
